// extracted by mini-css-extract-plugin
export var browseMoreNav = "featured-projects-grid-module--browseMoreNav--lPh5I typography-module--small--CJ-EH";
export var clickable = "featured-projects-grid-module--clickable--xuo7L";
export var grid = "featured-projects-grid-module--grid--Ex+7O";
export var gridCell = "featured-projects-grid-module--gridCell--038f1";
export var gridCellBottomLarge = "featured-projects-grid-module--gridCellBottomLarge--xmeWs";
export var gridCellFirstLarge = "featured-projects-grid-module--gridCellFirstLarge--XUqd-";
export var gridCellSecondLarge = "featured-projects-grid-module--gridCellSecondLarge--Ro9VP";
export var headline = "featured-projects-grid-module--headline--rb-ZI";
export var root = "featured-projects-grid-module--root--MxPmH";